type Cb<T extends {}> = (value: T[keyof T], key: keyof T, object: T) => {};

const forIn = <T extends {}>(cb: Cb<T>) => (obj: T) => {
  (Object.keys(obj) as (keyof T)[]).forEach(key => cb(obj[key], key, obj));
};

export default forIn;
